import { render } from "./CreateCommunityView.vue?vue&type=template&id=d1ccaadc"
import script from "./CreateCommunityView.vue?vue&type=script&lang=js"
export * from "./CreateCommunityView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__